<template>
  <div id="AccountDownloads" class="Main-Content">

    <Page
      :title="$t('Downloads')"
      size="fullWidth"
    >
      <Layout>
        <LayoutSection>
          <Card>
            <!-- <CardSection> -->
              <Filters
                ref="filters"
                :filters="[
                  {
                    key: 'fromDate',
                    label: $t('Start Date'),
                    type: 'date',
                    required: true
                  },
                  {
                    key: 'toDate',
                    label: $t('End Date'),
                    type: 'date'
                  },
                  {
                    key: 'type',
                    label: $t('Type'),
                    type: 'select',
                    options: [
                      { label: $t('Conversions'), value: 'conversions' },
                      { label: $t('Emails'), value: 'emails' },
                      { label: $t('Form Responses'), value: 'formResponses' },
                      { label: $t('Transactions'), value: 'transactions' },
                      { label: $t('Scheduled Reports'), value: 'scheduled-report'}
                    ]
                  },
                  {
                    key: 'status',
                    label: $t('Status'),
                    type: 'select',
                    options: [
                      { label: $t('Started'), value: 'started' },
                      { label: $t('Processing'), value: 'background' },
                      { label: $t('Uploading'), value: 'uploading' },
                      { label: $t('Complete'), value: 'complete' },
                      { label: $t('Error'), value: 'error' }
                    ]
                  }
                ]"
                :shortcuts="[
                  {
                    label: $t('Type'),
                    items: [
                      { label: $t('All'), onAction: () => setType('') },
                      { label: $t('Conversions'), onAction: () => setType('conversions') },
                      { label: $t('Emails'), onAction: () => setType('emails') },
                      { label: $t('Form Responses'), onAction: () => setType('formResponses') },
                      { label: $t('Transactions'), onAction: () => setType('transactions') }
                    ]
                  }
                ]"
                :applied-filters="filter"
                @update="updateFilter"
                :query="false"
                required
              />
            
              <DataTable
                :columns="[
                  {
                    key: 'type',
                    label: $t('Type')
                  },
                  {
                    key: 'statusNice',
                    label: $t('Status')
                  },
                  {
                    key: 'statusPercent',
                    label: $t('%')
                  },
                  {
                    key: 'details',
                    label: $t('Details')
                  },
                  {
                    key: 'createdOn',
                    label: $t('Created On'),
                    format: 'dateLong'
                  },
                  {
                    key: 'createdBy',
                    label: $t('Created By')
                  },
                  {
                    key: 'updatedOn',
                    label: $t('Updated On'),
                    format: 'dateLong'
                  },
                  {
                    key: 'updatedBy',
                    label: $t('Updated By')
                  }
                ]"
                :row-actions="(row) => getActions(row)"
                :rows="formattedDownloads"
                :loading="loadingState"
                :pagination="{
                  offset: offset,
                  limit: limit,
                  total: totalElements,
                  updateOffset: updateOffset,
                  updateLimit: updateLimit
                }"
              />
            <!-- </CardSection> -->
          </Card>
        </LayoutSection>
      </Layout>

    </Page>

  </div>
</template>

<script>
import _ from 'lodash'
import Utils from '../classes/utils/Utils'

export default {
  name: 'AccountDownloads',
  data () {
    return {
      loading: true,
      downloads: [],
      totalElements: null,
      totalLoading: true,
      filter: {
        fromDate: null,
        toDate: null,
        type: null,
        status: null
      },
      offset: 0,
      limit: 10,
      sortBy: {
        column: 'updatedOn',
        direction: 'desc'
      },
      cancelableDownloads: null,
      cancelableTotals: null
    }
  },
  async mounted() {
    NProgress.start()

    await this.setFilterFromQuery(false)

    this.$watch('$route', async () => {
      await this.setFilterFromQuery(true)
    }, { deep: true })

    this.limit = this.getTableLimit('tableLimit') || 10
    this.filterDownloads()
  },
  computed: {
    loadingState() {
      return {
        rows: this.loading,
        totals: false,
        footer: this.totalLoading
      }
    },
    formattedDownloads() {
      let downloads = this.downloads.map(e => {
        return {
          ...e,
          type: this.getType(e.type),
          statusNice: this.getStatus(e.status),
          createdBy: e.createdBy !== -1 ? e.createdBy : null
        }
      })
      if (this.sortBy) {
        downloads = _.orderBy(downloads, [this.sortBy.column], [this.sortBy.direction])
      }
      return downloads
    }
  },
  methods: {
    async setFilterFromQuery(makeApiCall = false) {
      if (this.$route.query) {
        this.filter = {}
        Object.keys(this.$route.query).forEach((k) => {
          if (this.$route.query[k]) {
            this.filter[k] = this.$route.query[k]
          } else {
            this.filter[k] = null
          }
        })
      } 
      if (!this.filter.fromDate) {
        this.filter.fromDate = '2010-01-01'
      }

      await this.$router.replace({ name: 'AccountDownloads', query: this.filter})
        .catch(this.duplicateRouteCatch)

      if (makeApiCall) {
        this.filterDownloads(true)
      }
    },
    setType(type) {
      this.filter.type = type
      this.filterDownloads()
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
      this.filterDownloads(false)
    },
    getType(type) {
      if (type === 'conversions') {
        return this.$t('Conversions')
      } else if (type === 'emails') {
        return this.$t('Emails')
      } else if (type === 'formResponses') {
        return this.$t('Form Responses')
      } else if (type === 'transactions') {
        return this.$t('Transactions')
      } else if (type === 'scheduled-report') {
        return this.$t('Scheduled Reports')
      }
      return '?'
    },
    getStatus(status) {
      if (status === 'started') {
        return this.$t('Started')
      } else if (status === 'background') {
        return this.$t('Processing')
      } else if (status === 'uploading') {
        return this.$t('Uploading')
      } else if (status === 'complete') {
        return this.$t('Complete')
      } else if (status === 'error') {
        return this.$t('Error')
      } else {
        return '?'
      }
    },
    updateOffset(offset) {
      this.offset = offset
      this.filterDownloads(false)
    },
    updateFilter(filter) {
      this.filter = filter
      this.filterDownloads()
    },
    updateUrl() {
      this.$router.push({ name: 'AccountDownloads', query: this.filter})
      .catch(this.duplicateRouteCatch)
    },
    filterDownloads(refreshTotals = true) {
      this.updateUrl()
      NProgress.start()
      this.downloads = []
      this.loading = true
      if (this.cancelableDownloads) this.cancelableDownloads.cancel()
      this.cancelableDownloads = Utils.makeCancelablePromise(
        this.api.getDownloads(this.filter, this.limit, this.offset)
      )
      this.cancelableDownloads.promise
        .then((data) => {
          this.downloads = data
        })  
        .catch((e) => {
          if (!e.isCanceled) {
            this.apiCatch(e)
          }
        })
        .finally(() => {
          this.loading = false
          NProgress.done()
        })

      if (refreshTotals) {
        this.totalElements = null
        this.totalLoading = true
        if (this.cancelableTotals) this.cancelableTotals.cancel()
        this.cancelableTotals = Utils.makeCancelablePromise(
          this.api.getDownloadsTotal(this.filter)
        )
        this.cancelableTotals.promise
          .then((data) => {
            this.totalElements = data
            this.totalLoading = false
          })
          .catch((e) => {
            if (!e.isCanceled) {
              this.apiCatch(e)
            }
          })
      }
    },
    download(id) {
      NProgress.start()
      this.exporting = true
      this.api.getDownloadSignedUrl(id)
      .then((url) => {
        window.open(url)
      })
      .catch(this.apiCatch)
      .finally(() => {
        this.exporting = false
        NProgress.done()
      })
    },
    getActions(row) {
      if (row.status === 'complete') {
        return [{
          label: this.$t('Download'),
          onAction: (row) => this.download(row.id)
        }]
      } else {
        return [{
          label: '-',
        }]
      }
    }
  }
}

</script>
